/**
 * ActivationsValidationSummary - dynamic summary cards (ITRTL-720)
 *
 * Unlike MenuValidation/ValidationSummary (which has a fixed set of cards), this renders one card
 * per validation the selected aggregator actually checks — driven by `applicableValidations` — and
 * counts the failing entities for each directly from the validation results. This keeps the cards
 * in lockstep with the dynamic table columns: no missing cards for new validation types, and no
 * irrelevant cards for checks the aggregator doesn't run.
 */

/* eslint-disable react/prop-types */
import React from "react";
import { VALIDATION_STATUS } from "../../utils/enums";
import { getValidationLabel, orderValidationTypes } from "../../utils/validationFields";

const ActivationsValidationSummary = ({ results, applicableValidations }) => {
  const types = orderValidationTypes(applicableValidations);
  if (!types.length) {
    return null;
  }

  const safeResults = results || [];

  const countIssues = (type) =>
    safeResults.filter((item) => {
      const field = item.validation && item.validation[type];
      return field && (field.status === VALIDATION_STATUS.MISSING
        || field.status === VALIDATION_STATUS.INVALID);
    }).length;

  return (
    <div className="ls-validation-summary">
      <div className="ls-validation-summary-grid">
        {types.map((type) => {
          const count = countIssues(type);
          const tone = count > 0 ? "error" : "success";
          return (
            <div key={type} className="ls-validation-summary-card">
              <div className={`ls-validation-summary-card-icon ls-validation-summary-card-icon--${tone}`}>
                {count > 0 ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </div>
              <div className="ls-validation-summary-card-content">
                <p className="ls-validation-summary-card-label">{getValidationLabel(type)}</p>
                <p className="ls-validation-summary-card-value">{count}</p>
                <p className="ls-validation-summary-card-unit">
                  {count === 1 ? "issue" : "issues"}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivationsValidationSummary;
